import React, { useState } from "react";
import { MenuItem } from "@mui/material";
import { getTranslateByKey, isNullUndefined } from "@/main/services/utils";

import { useDispatch } from "react-redux";
import { changeParameterTypeValue } from "@/main/store/parameterTypeValue";
import { ParameterTypeValueEnum } from "@/main/services/enum/ParameterTypeValueEnum";
import {
	getSeparatorDecimal,
	hasComma,
	isValidNumberValue,
	quantityNumbers,
	removeCommaDot,
	removeNegative,
	valueWithNumberCommaNegative,
} from "./utilsParameterTypeValueComponent";

import * as S from "./styles";

interface IParameterTypeValueComponent {
	idParameterTypeRow: number;
	id: string;
	maxAcceptValue: number;
	value: string | null;
	typeValue: number;
	handleValue: (idParameterTypeRow: number, id: string, newValue: string | null) => void;
	oldValue: string | undefined;
}

function ParameterTypeValueComponent({
	idParameterTypeRow,
	id,
	maxAcceptValue,
	value,
	typeValue,
	handleValue,
	oldValue,
}: IParameterTypeValueComponent) {
	const [edit, setEdit] = useState(false);
	const [newValue, setNewValue] = useState<string | null>(value);
	const dispatch = useDispatch();
	const handleClick = () => {
		setEdit(true);
	};

	const handleBlur = () => {
		let value: string | null;

		if (newValue && newValue.endsWith(getSeparatorDecimal(newValue))) {
			value = newValue.slice(0, -1);
		} else {
			value = newValue;
		}
		handleValue(idParameterTypeRow, id, value);
		setEdit(false);
	};

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const OPTIONS_VALIDATE = {
			maxCharactersNumbers: maxAcceptValue,
			decimalLimit: 2,
			clearSeparator: false,
		};
		const formattedOldValue = isNullUndefined(oldValue) ? "" : oldValue;

		if (typeValue === ParameterTypeValueEnum.Boolean && event.target.value === "null") {
			dispatch(changeParameterTypeValue(false, false, null));
			return setNewValue(null);
		}
		const numbersTypeValue = [
			ParameterTypeValueEnum.Integer,
			ParameterTypeValueEnum.Decimal,
			ParameterTypeValueEnum.SignedInteger,
			ParameterTypeValueEnum.SignedDecimal,
		];

		if (numbersTypeValue.includes(typeValue)) {
			// #region General Validate
			const isValidValue = isValidNumberValue(event.target.value);
			if (!isValidValue) return setNewValue((prev) => prev);

			const separatorValue = getSeparatorDecimal(event.target.value);
			if (hasComma(event.target.value)) return setNewValue((prev) => prev);

			const valueQuantityNumbersEvent = quantityNumbers(event.target.value);
			if (valueQuantityNumbersEvent > OPTIONS_VALIDATE.maxCharactersNumbers) return setNewValue((prev) => prev);

			const isDecimalLimit = event.target.value.split(separatorValue)[1]?.length > OPTIONS_VALIDATE.decimalLimit;
			if (isDecimalLimit) return setNewValue((prev) => prev);

			//#endregion
			const valueWithCharacters = valueWithNumberCommaNegative(event.target.value);

			if (typeValue === ParameterTypeValueEnum.Integer) {
				const onlyNumber = removeCommaDot(valueWithCharacters);
				const formattedValue = removeNegative(onlyNumber);
				return setNewValue(formattedValue);
			}

			if (typeValue === ParameterTypeValueEnum.SignedInteger) {
				const onlyNumber = removeCommaDot(valueWithCharacters);
				return setNewValue(onlyNumber);
			}

			if (typeValue === ParameterTypeValueEnum.Decimal) {
				const formattedValue = removeNegative(valueWithCharacters);
				return setNewValue(formattedValue);
			}

			return setNewValue(valueWithCharacters);
		} else {
			const haveChange = event.target.value !== formattedOldValue;
			dispatch(changeParameterTypeValue(haveChange, false, null));

			handleValue(idParameterTypeRow, id, event.target.value);

			setNewValue(event.target.value || null);
		}
	};

	if (edit) {
		switch (typeValue) {
			case ParameterTypeValueEnum.Integer:
			case ParameterTypeValueEnum.SignedInteger:
			case ParameterTypeValueEnum.Decimal:
			case ParameterTypeValueEnum.SignedDecimal:
				return (
					<S.InputText
						id="id-register-input-integer"
						type="text"
						value={newValue}
						onChange={handleChange}
						onBlur={handleBlur}
						autoFocus
					/>
				);
			case ParameterTypeValueEnum.String:
				return (
					<S.InputText
						id="id-register-input-string"
						type="text"
						value={newValue}
						onChange={handleChange}
						onBlur={handleBlur}
						inputProps={{ maxLength: maxAcceptValue }}
						autoFocus
					/>
				);
			case ParameterTypeValueEnum.Boolean:
				return (
					<S.InputText
						id="id-register-input-boolean"
						select
						required
						key={String(newValue || null)}
						value={String(newValue || null)}
						onChange={handleChange}
						onBlur={handleBlur}
						autoFocus
					>
						<MenuItem key="true" value="true">
							{getTranslateByKey("information.yes")}
						</MenuItem>
						<MenuItem key="false" value="false">
							{getTranslateByKey("information.no")}
						</MenuItem>
					</S.InputText>
				);
		}
	}
	function renderValue() {
		switch (newValue) {
			case "true":
				return <>{getTranslateByKey("information.yes")}</>;
			case "false":
				return <>{getTranslateByKey("information.no")}</>;
			default:
				return newValue || <>{getTranslateByKey("information.nd")}</>;
		}
	}
	return (
		<S.ShowValue id="id-register-input-showValue" onClick={handleClick}>
			{renderValue()}
		</S.ShowValue>
	);
}

export default ParameterTypeValueComponent;
